export default "__VITE_ASSET__a3818750__"